<template>
  <section v-if="isVisible" class="PlanSelector">
    <h3 class="PlanSelector-heading">ご利用プラン</h3>

    <section v-for="plan in plans" :key="plan.value" class="PlanList">
      <div class="PlanList-inner">
        <div class="PlanList-titleWrapper">
          <h4 class="PlanList-title">
            <label class="PlanList-title-inner t-label" :for="plan.id">
              <i
                class="PlanList-checkbox fas fa-check"
                :class="{ 'is-checked': thisValue === plan.value }"
              ></i>
              <span v-if="field.hasHtml" class="PlanList-label" v-html="plan.title"></span>
              <span v-else class="PlanList-label" v-text="plan.title"></span>
            </label>
          </h4>
        </div>

        <ul v-if="plan.value === 'free'" class="PlanList-list">
          <li
            v-for="item in contentLists.free"
            :key="item.text"
            class="PlanList-list-item"
            :class="getClassOfPlanContent(item.bullet || 'dot')"
          >
            {{ item.text }}
          </li>
        </ul>
      </div>
    </section>

    <p class="PlanSelector-note">
      ※Freeプランの提供内容は今後変更される可能性があります。
      <template v-if="currentPlanRank > 1">
        <br />
        <span
          >※<a href="mailto:insight.markets@enechange.co.jp"
            >プランのグレードダウンは営業にお問合せください。</a
          ></span
        >
      </template>
    </p>

    <ValidationProvider
      :name="field.errorLabel"
      :vid="field.name"
      :rules="field.rules"
      tag="div"
      class="PlanSelector-inputs"
    >
      <label v-for="plan in plans" :key="plan.value">
        <input
          :id="plan.id"
          v-model="thisValue"
          :v-if="getIsSelectable(plan.rank)"
          class="PlanSelector-input"
          type="radio"
          :name="field.name"
          :value="plan.value"
        />
      </label>
    </ValidationProvider>
  </section>
</template>

<script>
import FormItem from '../../mixins/FormItem'

import getClassOfPlanContent from '../../functions/getClassOfPlanContent'

import contentLists from '../../data/contentLists'

export default {
  name: 'PlanSelector',
  mixins: [FormItem],
  data() {
    return {
      currentUser: gon.current_user || {},
    }
  },
  computed: {
    contentLists,
    contentField() {
      return this.field.subFields[0]
    },
    plans() {
      return [
        {
          value: 'free',
          rank: 1,
          id: `${this.field.name}-free`,
          title: 'Freeプラン(無料会員登録)のみ',
        },
      ]
    },
    currentPlanRank() {
      return this.currentUser.plan_rank
    },
  },
  watch: {
    thisValue(value) {
      if (value === 'free') {
        this.setValue({ name: this.contentField.name, value: [] })
      }
    },
  },
  methods: {
    setValue(value) {
      this.$store.commit(`${this.namespace}/setValue`, value)
    },
    getClassOfPlanContent,
    onChange(val) {
      this.thisValue = val
    },
    getIsSelectable(rank) {
      return rank >= (this.currentPlanRank ?? 0)
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../../css/foundation/vars';
@import '../../css/vue_modules/plan_list';

.PlanSelector {
  margin-top: 4rem;

  &:first-child {
    margin-top: 0;
  }

  .Description + & {
    margin-top: 2.4rem;
  }
}

.PlanSelector-inputs {
  display: none;
}

.PlanSelector-heading {
  padding-left: 0.5rem;
  font-size: 1.4rem;
  font-weight: bold;
}

.PlanList {
  margin-top: 2rem;

  + .PlanList {
    margin-top: 3.6rem;
  }
}

.PlanList-inner {
  border-color: #414141;
}

.PlanList-title {
  background: vars.$color-bg-0;
}

.PlanSelector-note {
  padding-left: 3.2rem;
  margin-top: 1.4rem;
  font-size: 1.6rem;
  color: #707070;

  a {
    color: vars.$color-btn-accept;
    text-decoration: underline;
    transition: filter 0.2s ease;

    &:hover {
      filter: brightness(1.3);
    }
  }
}
</style>
